import 'Styles/templates/product.second-turn.scss';

import pdpFirstFold from '../vue/pdp-first-fold/index';
import showMoreLess from '../components/show-more-less';

pdpFirstFold();
showMoreLess();